import { render, staticRenderFns } from "./NomineeDirector.vue?vue&type=template&id=01981394&scoped=true&"
import script from "./NomineeDirector.vue?vue&type=script&lang=js&"
export * from "./NomineeDirector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01981394",
  null
  
)

export default component.exports